/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-11-04 15:23:08
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-07 18:15:18
 */
import request from '@/utils/request';
import { AjaxMethod } from '@/utils/dataMap';
// 样品订单列表
export const sampleList = params => {
	return request({
		url: '/api/sample-order/sample-list',
		data: params,
		method: AjaxMethod.post,
	});
};

// 获取自定义表头设置
export const layoutGetField = params => {
	return request({
		url: '/api/layout/get-field',
		params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 样品订单列表统计
export const sampleStatisticalAll = params => {
	return request({
		url: '/api/sample-order/sample-list-static-all',
		data: params,
		method: AjaxMethod.post,
	});
};
// 样品订单列表统计
export const sampleStatistical = params => {
	return request({
		url: '/api/sample-order/sample-list-static',
		data: params,
		method: AjaxMethod.post,
	});
};
// 样品订单各个状态总数
export const sampleStatusNum = params => {
	return request({
		url: '/api/sample-order/sample-list-status-num',
		data: params,
		method: AjaxMethod.post,
	});
};
// 导出样品订单
export const exportSampleList = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/export-sample-list',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
// 联系商家
export const sampleOrderMerchant = params => {
	return request({
		url: '/api/sample-order/contact-merchant',
		data: params,
		method: AjaxMethod.post,
	});
};
// 获取单个商品的申样门槛
export const getSampleRule = (params, notOrigin = true) => {
	return request({
		url: '/api/product-info/get-sample-rule',
		params,
		method: AjaxMethod.get,
		notOrigin,
	});
};
// 设置商品申样门槛
export const setSampleRule = (params, notOrigin = true) => {
	return request({
		url: '/api/product-info/set-sample-rule',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 批量物流单号
export const orderBatchDeliver = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-deliver',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
//根据物流单号获取物流公司
export const getDeliveryInfo = params => {
	return request({
		url: '/api/sample-order/get-delivery-name-by-cn',
		params: params,
		method: AjaxMethod.get,
		notOrigin: true,
	});
};

// 设置样品审核规则
export const setAuditConf = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/set-audit-conf',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 获取样品审核规则
export const getAuditConf = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/get-audit-conf',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 协作样品订单审核拒绝
export const sampleAuditRefuse = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/sample-audit-refuse',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 协作样品订单批量审核拒绝
export const batchSampleAuditRefuse = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-sample-audit-refuse',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 协作样品订单审核通过
export const sampleAuditPass = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/sample-audit-pass',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 协作样品订单批量审核通过
export const batchsampleAuditPass = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-sample-audit-pass',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 取消样品协作
export const batchCancelCooperate = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-cancel-cooperate',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 单个同步样品协作
export const singleSyncCooperate = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/sync-cooperate',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 单个同步星选协作
export const singleSyncPartnerCooperate = (params, notOrigin = true) => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-sync',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 取消星选样品协作
export const cancelPartnerCooperate = (params, notOrigin = true) => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-cancel',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 批量同步星选商品
export const batchSyncPartnerCooperate = (params, notOrigin = true) => {
	return request({
		url: 'sample-api/v1/partner/cooperate/cooperation-partner-batch-sync',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};

// 批量同步样品协作
export const batchSyncCooperate = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-sync-cooperate',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 批量拒绝发货列表
export const batchRejectList = (params, notOrigin = true) => {
	return request({
		url: '/api/sample-order/batch-refuse-deliver-list',
		data: params,
		method: AjaxMethod.post,
		notOrigin,
	});
};
// 批量拒绝发货
export const batchRejectShipment = params => {
	return request({
		url: '/api/sample-order/batch-refuse-deliver',
		data: params,
		method: AjaxMethod.post,
	});
};

// 批量导入
export const batchImport = params => {
	return request({
		url: '/api/sample-order/import',
		data: params,
		method: AjaxMethod.post,
	});
};
// 导入记录
export const importRecords = params => {
	return request({
		url: '/api/sample-order/import-record',
		data: params,
		method: AjaxMethod.post,
	});
};
// 修改申样信息-更新商品规格
export const updateProductSpec = params => {
	return request({
		url: '/api/sample-order/sync-skus',
		data: params,
		method: AjaxMethod.post,
	});
};

// 修改申样备注
export const setSampleRemarkApi = params => {
	return request({
		url: '/api/sample-order/set-remark',
		data: params,
		method: AjaxMethod.post,
	});
};
// 多个样品订单添加单个标签
export const batchSetSampleTag = params => {
	return request({
		url: '/api/tags/batch-set-sample-tag',
		data: params,
		method: AjaxMethod.post,
	});
};
// 单个样品订单添加多个标签
export const setSampleTag = params => {
	return request({
		url: '/api/tags/set-sample-tags',
		data: params,
		method: AjaxMethod.post,
	});
};
// 样品标签数量校验
export const checkSampleTag = params => {
	return request({
		url: '/api/tags/check-sample-tag',
		data: params,
		method: AjaxMethod.post,
	});
};
